import type { ReactNode } from 'react'
import { useEffect, useRef, useState } from 'react'
import { useRouter } from 'next/router'
import { styled } from 'styled-components'

const ENTER_FROM = {
  forward: 100,
  back: -100
}

const DURATION_MS = 300

const Slide = styled.div<{ $from: number }>`
  position: absolute;
  width: 100%;
  height: 100vh;
  animation: animate-slide-in ${DURATION_MS}ms ease;

  @keyframes animate-slide-in {
    from {
      transform: translateX(${({ $from }) => $from}%);
    }
    to {
      transform: translateX(0);
    }
  }
`

type AnimateProps = {
  children?: ReactNode
}

const Animate = ({ children }: AnimateProps) => {
  const router = useRouter()
  const isPop = useRef(false)
  const [from, setFrom] = useState(ENTER_FROM.forward)

  useEffect(() => {
    // beforePopState only fires for browser back/forward navigations.
    router.beforePopState(() => {
      isPop.current = true
      return true
    })

    const handleRouteChangeStart = () => {
      setFrom(isPop.current ? ENTER_FROM.back : ENTER_FROM.forward)
      isPop.current = false
    }

    router.events.on('routeChangeStart', handleRouteChangeStart)

    return () => {
      router.events.off('routeChangeStart', handleRouteChangeStart)
      router.beforePopState(() => true)
    }
  }, [router])

  return (
    <Slide key={router.asPath} $from={from}>
      {children}
    </Slide>
  )
}

export default Animate
